import React from 'react'
import SEO from '../seo'
import styles from './Contact.module.css'
import ContactItem from '../contact-item'
import PageTitle from '../page-title'

const email = 'mayurpankhevents@gmail.com'
const phoneNumber = '8800341266'

const Contact = () => {
  return (
    <div className={styles.container}>
      <SEO title="About" />

      <PageTitle>Contact us</PageTitle>

      <p>
        If you're interested in working together, get in touch with us by email
        or by phone
      </p>

      <ContactItem name="email" value={email}></ContactItem>
      <ContactItem name="telephone" value={phoneNumber}></ContactItem>

      <br />
      <hr></hr>
      <h4 className={styles.companyInfoTitle}>Company Information</h4>
      <div>Company Name: Mayurpankh Events</div>
    </div>
  )
}

export default Contact
